import DelegateOrderByHeader from './DelegateOrderByHeader.js'
import DelegateForm from './DelegateForm.js'
import DelegateCard from './DelegateCard.js'

export default {
    form: DelegateForm,
    card: DelegateCard,
    orderByHeader: DelegateOrderByHeader,
}
